export default __webpack_public_path__ + "static/media/Snd_I_Starts.bbd626cd.mp3";